// AddClient.js
import React, { useState } from "react";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { addClient } from "./api";
import "./AddClient.css"; // ✅ Import obligatoire

function AddClient() {
  const [form, setForm] = useState({
    contact: "",
    nom_entreprise: "",
    adresse: "",
    code_postal: "",
    ville: "",
    telephone: "",
    email: "",
    reference_client: ""
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success"); // 'success' | 'destructive'
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addClient(token, form);
      setMessageType("success");
      setMessage("Client ajouté !");
    } catch (err) {
      setMessageType("destructive");
      setMessage("Une erreur est survenue lors de l'ajout.");
    }
    setForm({
      contact: "",
      nom_entreprise: "",
      adresse: "",
      code_postal: "",
      ville: "",
      telephone: "",
      email: "",
      reference_client: ""
    });
  };

  return (
    <div className="form-container">
      <h2>Ajouter un client</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label>Nom du client *</label>
            <input
              type="text"
              name="contact"
              value={form.contact}
              onChange={handleChange}
              placeholder="Nom du client"
              required
            />
          </div>

          <div className="form-group">
            <label>Nom entreprise *</label>
            <input
              type="text"
              name="nom_entreprise"
              value={form.nom_entreprise}
              onChange={handleChange}
              placeholder="Nom de l'entreprise"
              required
            />
          </div>

          <div className="form-group">
            <label>Adresse</label>
            <input
              type="text"
              name="adresse"
              value={form.adresse}
              onChange={handleChange}
              placeholder="Adresse"
            />
          </div>

          <div className="form-group">
            <label>Code postal</label>
            <input
              type="text"
              name="code_postal"
              value={form.code_postal}
              onChange={handleChange}
              placeholder="Code postal"
            />
          </div>

          <div className="form-group">
            <label>Ville</label>
            <input
              type="text"
              name="ville"
              value={form.ville}
              onChange={handleChange}
              placeholder="Ville"
            />
          </div>

          <div className="form-group">
            <label>Téléphone <span className="optional">Facultatif</span></label>
            <input
              type="tel"
              name="telephone"
              value={form.telephone}
              onChange={handleChange}
              placeholder="06 00 00 00 00"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="exemple@email.com"
            />
          </div>

          <div className="form-group">
            <label>Référence client</label>
            <input
              type="text"
              name="reference_client"
              value={form.reference_client}
              onChange={handleChange}
              placeholder="Référence client"
            />
          </div>

          <div className="btn-container">
            <button type="submit" className="btn">Enregistrer</button>
          </div>
        </div>
      </form>

      {message && (
        <div className={`alert ${messageType === 'destructive' ? 'alert-destructive' : 'alert-success'}`} role="alert">
          <div className="alert-icon">
            {messageType === 'destructive' ? (
              <WarningCircle size={20} weight="duotone" />
            ) : (
              <CheckCircle size={20} weight="duotone" />
            )}
          </div>
          <div className="alert-content">
            <div className="alert-title">{messageType === 'destructive' ? 'Erreur' : 'Succès !'}</div>
            <div className="alert-description">{message}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddClient;